import { supabase } from '../config/supabaseClient';

export function calculateDiscount(coupon, subtotal) {
  if (!coupon) return 0;

  let discount = 0;
  if (coupon.discount_type === 'percentage') {
    discount = Math.round((subtotal * coupon.discount_value) / 100);
    if (coupon.max_discount != null) {
      discount = Math.min(discount, coupon.max_discount);
    }
  } else {
    discount = coupon.discount_value;
  }

  return Math.min(discount, subtotal);
}

export async function validateCoupon(code, subtotal) {
  const normalized = code.trim().toUpperCase();
  if (!normalized) {
    return { valid: false, error: 'Enter a coupon code' };
  }

  const { data, error } = await supabase
    .from('coupons')
    .select('*')
    .eq('code', normalized)
    .eq('is_active', true)
    .maybeSingle();

  if (error) throw error;
  if (!data) {
    return { valid: false, error: 'Invalid or expired coupon code' };
  }

  const now = new Date();
  if (data.valid_from && new Date(data.valid_from) > now) {
    return { valid: false, error: 'This coupon is not active yet' };
  }
  if (data.valid_until && new Date(data.valid_until) < now) {
    return { valid: false, error: 'This coupon has expired' };
  }
  if (data.usage_limit != null && data.used_count >= data.usage_limit) {
    return { valid: false, error: 'This coupon has reached its usage limit' };
  }
  if (subtotal < data.min_order_amount) {
    return {
      valid: false,
      error: `Minimum order of ₹${data.min_order_amount.toLocaleString()} required`,
    };
  }

  const discountAmount = calculateDiscount(data, subtotal);
  return {
    valid: true,
    coupon: data,
    discountAmount,
  };
}

export async function incrementCouponUsage(couponId) {
  const { data: coupon, error: fetchError } = await supabase
    .from('coupons')
    .select('used_count')
    .eq('id', couponId)
    .single();

  if (fetchError) throw fetchError;

  const { error } = await supabase
    .from('coupons')
    .update({ used_count: (coupon.used_count || 0) + 1 })
    .eq('id', couponId);

  if (error) throw error;
}
